import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NRCircleLowIcon from '../../../NRIcons/NRCircleLowIcon';
import NRCircleMediumIcon from '../../../NRIcons/NRCircleMediumIcon';
import NRCircleHighIcon from '../../../NRIcons/NRCircleHighIcon';
import NRCircleWarningIcon from '../../../NRIcons/NRCircleWarningIcon';
import { capitalizeFirstLetter } from '../../../utils/utils';

export const NRConfidenceFormatter = ({ value, row }) => {
  const theme = useTheme();

  function getIcon(confidence) {
    switch (confidence) {
      case 'LOW':
        return <NRCircleLowIcon height="20" width="20" color={theme.palette.text.iconInfo} />;
      case 'MEDIUM':
        return <NRCircleMediumIcon height="20" width="20" color={theme.palette.text.iconInfo} />;
      case 'HIGH':
        return <NRCircleHighIcon height="20" width="20" color={theme.palette.text.iconInfo} />;
      default:
        return null;
    }
  }
  const lowercaseValue = String(value).toLowerCase();
  const valueToShow = lowercaseValue === 'unspecified' ? '-' : capitalizeFirstLetter(lowercaseValue);
  const icon = getIcon(value);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'default',
        gap: theme.spacing(0.5)
      }}
    >
      {icon && (
        <Box
          sx={{
            marginRight: theme.spacing(0.75),
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="body2" children={valueToShow} />
    </Box>
  );
};
export const NRConfidenceProvider = props => <DataTypeProvider formatterComponent={NRConfidenceFormatter} {...props} />;
